import { NewNetworkPage } from "fleet/view/network/new";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getVistarAccountIds } from "redux-store/auth";
import { CREATE_NETWORK } from "redux-store/networks/actions";
import { LOAD_VISTAR_ACCOUNT_NETWORKS } from "redux-store/vistar-accounts/actions";

function mapStateToProps(state) {
  const vistarAccountIds = getVistarAccountIds(state);

  return {
    vistarAccountIds,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addNewNetwork: (serviceArgs) => {
      return createPromiseApiAction(dispatch, CREATE_NETWORK, [
        serviceArgs.name,
        serviceArgs.vistarNetwork,
      ]);
    },
    fetchVistarAccountNetworks: () => {
      return createPromiseApiAction(dispatch, LOAD_VISTAR_ACCOUNT_NETWORKS);
    },
  };
}

const ConnectedNewNetworkPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewNetworkPage);

export { ConnectedNewNetworkPage };
